// export const CUSTOM_SELECT_COLOR_RED="custom-select-option-red";
// export const CUSTOM_SELECT_COLOR_BLUE="custom-select-option-blue";
// export const CUSTOM_SELECT_COLOR_WHITE="custom-select-option-white";

export const CUSTOM_SELECT_COLOR_RED="custom-select-container-red";
export const CUSTOM_SELECT_COLOR_BLUE="custom-select-container-blue";
export const CUSTOM_SELECT_COLOR_WHITE="custom-select-container-white";
export const CUSTOM_SELECT_PROFILE="custom-select-container-profile";